import { HttpContext, HttpContextToken, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { NotificationService } from '../services/notification.service';

/**
 * Не показывать общий тост об ошибке: вызывающий код сам объяснит причину.
 *
 * Нужен там, где ответ 400 — это не сбой, а осмысленный отказ, и у экрана есть
 * что сказать понятнее и на языке пользователя. Без этого поверх точного
 * сообщения ложится второе, общее, и читаются они как две разные беды.
 */
export const SKIP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);

/** Готовый контекст для такого вызова — короче, чем собирать его на месте. */
export function quietErrors(): HttpContext {
  return new HttpContext().set(SKIP_ERROR_TOAST, true);
}

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const notificationService = inject(NotificationService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Only show notifications for non-401 errors
      // 401 errors should be handled by auth guard/service
      if (error.status !== 401 && !req.context.get(SKIP_ERROR_TOAST)) {
        notificationService.showHttpError(error);
      }
      
      return throwError(() => error);
    })
  );
};